export class PanelContentStyle {
  marginTop = 'uk-margin-small-top';

  static normalize(styles: Partial<PanelContentStyle>): PanelContentStyle {
    const pureStyles = new PanelContentStyle();

    pureStyles.marginTop = styles.marginTop ?? pureStyles.marginTop;

    return pureStyles;
  }
}
